const leadsActionTypes = {
    SET_LEADS_OBJECT:'SET_LEADS_OBJECT',
    ADD_LEAD:'ADD_LEAD',
    EDIT_LEAD:'EDIT_LEAD',
    CLOSE_LEAD:'CLOSE_LEAD'
}

export default leadsActionTypes